export default __webpack_public_path__ + "static/media/baby34.64b4dff0.gif";